/**
 * Shared UI components for the Threebie Compliance Platform
 */
import React from 'react';

// Category metadata used across the app
export const CATEGORIES = {
  security: { label: "Security", color: "#FF00BE" },
  availability: { label: "Availability", color: "#059669" },
  processing_integrity: { label: "Processing Integrity", color: "#7c3aed" },
  confidentiality: { label: "Confidentiality", color: "#d97706" },
  privacy: { label: "Privacy", color: "#dc2626" },
};

export const STATUS_COLORS = {
  passing: "#059669",
  failing: "#dc2626",
  warning: "#d97706",
  not_implemented: "#6b7280",
  not_applicable: "#9ca3af",
  manual_review: "#7c3aed",
};

export function ProgressRing({ pct, size = 100, stroke = 8, color = "#FF00BE" }) {
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (pct / 100) * circ;
  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="var(--ring-bg, #2a2d3a)" strokeWidth={stroke} />
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth={stroke}
        strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round"
        style={{ transition: "stroke-dashoffset 1s ease" }} />
    </svg>
  );
}

export function Badge({ children, color = "#6b7280", style = {} }) {
  return (
    <span style={{ 
      display: "inline-block", 
      padding: "2px 10px", 
      borderRadius: 999, 
      fontSize: 11, 
      fontWeight: 700,
      letterSpacing: "0.04em", 
      background: color + "18", 
      color, 
      textTransform: "uppercase",
      ...style
    }}>
      {children}
    </span>
  );
}

export function Card({ children, style = {}, onClick, className = "" }) {
  return (
    <div 
      onClick={onClick} 
      className={`threebie-card ${onClick ? 'clickable' : ''} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}

export function StatCard({ label, value, sub, color }) {
  return (
    <Card>
      <div className="stat-label">{label}</div>
      <div className="stat-value" style={{ color: color || "var(--text)" }}>{value}</div>
      {sub && <div className="stat-sub">{sub}</div>}
    </Card>
  );
}
